import { Component, OnInit, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-broker-dropdown',
  templateUrl: './broker-dropdown.component.html',
  styleUrls: ['./broker-dropdown.component.css']
})
export class BrokerDropdownComponent implements OnInit, OnChanges {
  @Input() preSelected?
  @Output() selectedBroker = new EventEmitter<any>();
  showList = false;
  submitted = false;
  brokers = [

    {
      name: "Kaiser VC",
      imageURL: "assets/images/allBrokers/kaiservc.png",
      value: "kaiservc",
      isShow: false
    },

    {
      name: "Logisticare",
      imageURL: "assets/images/allBrokers/logisticare.png",
      value: "logisticscare",
      isShow: false
    },
    {
      name: "MTM",
      imageURL: "assets/images/allBrokers/mtm.png",
      isShow: false,
      value: "first"
    },
    {
      name: "CalOptima",
      imageURL: "assets/images/allBrokers/caloptima.png",
      isShow: false,
      value: "caloptima"
    },
    {
      name: "MED Trans",
      imageURL: "assets/images/allBrokers/medtrans.png",
      isShow: false,
      value: "medtrans"
    },
    {
      name: "Safe Ride",
      imageURL: "assets/images/allBrokers/saferide.png",
      isShow: false,
      value: "saferide"
    },
    {
      name: "Tennessee Carriers",
      imageURL: "assets/images/allBrokers/tncarrier.png",
      isShow: false,
      value: "tncarrier"
    },
    {
      name: "VEYO",
      imageURL: "assets/images/allBrokers/veyo.png",
      isShow: false,
      value: "veyo"
    },
    {
      name: "Southeast Trans",
      imageURL: "assets/images/allBrokers/southeastrans.png",
      isShow: false,
      value: "united"
    },
    {
      name: "LCP",
      imageURL: "assets/images/allBrokers/lcp.png",
      isShow: false,
      value: "lcp"
    },
    {
      name: "EPIC",
      imageURL: "assets/images/allBrokers/epic.png",
      isShow: false,
      value: "epic"
    },
    {
      name: "MAS",
      imageURL: "assets/images/allBrokers/mas.png",
      isShow: false,
      value: "mas"
    },
    {
      name: "ABC Insurance",
      imageURL: "assets/images/allBrokers/abcinsurance.png",
      isShow: false,
      value: "abcinsurance"
    },
    {
      name: "Call The Car",
      imageURL: "assets/images/allBrokers/callthecar.png",
      isShow: false,
      value: "callthecar"
    },
    {
      name: "Access2Care",
      imageURL: "assets/images/allBrokers/access2Ride.png",
      isShow: false,
      value: "access2Ride"
    },
    {
      name: "Welltrans",
      imageURL: "assets/images/allBrokers/welltrans.png",
      isShow: false,
      value: "welltrans"
    },
    {
      name: "Ride2MD",
      imageURL: "assets/images/allBrokers/ride2md.png",
      isShow: false,
      value: "ride2md"
    },
    {
      name: "Modivcare",
      imageURL: "assets/images/allBrokers/modivcare.png",
      isShow: false,
      value: "modivcare"
    },
    {
      name: "American Logistics",
      imageURL: "assets/images/allBrokers/americanLogistics.png",
      isShow: false,
      value: "americanLogistics"
    },
    {
      name: "Provide A Ride",
      imageURL: "assets/images/allBrokers/providearide.png",
      isShow: false,
      value: "providearide"
    },
    {
      name: "One Call",
      imageURL: "assets/images/allBrokers/onecallcare.png",
      isShow: false,
      value: "onecall"
    },
    {
      name: "FACT SD",
      imageURL: "assets/images/allBrokers/factSd.png",
      isShow: false,
      value: "factSd"
    },
    {
      name: "Valley Metro",
      imageURL: "assets/images/allBrokers/valley-metro.png",
      isShow: false,
      value: "valleymetro"
    },
    {
      name: "Secure Transportation",
      imageURL: "assets/images/allBrokers/secure-transportation.png",
      isShow: false,
      value: "secure"
    },
    {
      name: "General Transportation",
      imageURL: "assets/images/allBrokers/general- transportation.png",
      isShow: false,
      value: "general"
    },



    {
      name: "ProTransport-1",
      imageURL: "assets/images/allBrokers/protransvc.png",
      isShow: false,
      value: "protransvc"
    }, {
      name: "InnovAge California",
      imageURL: "assets/images/allBrokers/innovage.png",
      isShow: false,
      value: "innovagevc"
    }, {
      name: "UC Davis Rehabilitation Hospital",
      imageURL: "assets/images/allBrokers/ucdavis.png",
      isShow: false,
      value: "ucdavis"
    }, {
      name: "Ernest Health",
      imageURL: "assets/images/allBrokers/enresthealth.png",
      isShow: false,
      value: "ernesthealth"
    }, {
      name: "CommonSpirit Health California",
      imageURL: "assets/images/allBrokers/commonspirit.png",
      isShow: false,
      value: "cshca"
    },
    {
      name: "RouteGenie",
      imageURL: "assets/images/allBrokers/ruotegeine.png",
      isShow: false,
      value: "routegenie"
    },
    {
      name: "Kinetik",
      imageURL: "assets/images/allBrokers/kinetik.png",
      isShow: false,
      value: "kinetik"
    },
    {
      name: "Sutter",
      imageURL: "assets/images/allBrokers/sutter.png",
      isShow: false,
      value: "sutter"
    },
    {
      name: "AWMT",
      imageURL: "assets/images/allBrokers/awmt.png",
      isShow: false,
      value: "awmt"
    },
    {
      name: "Partnership Health Plan",
      imageURL: "assets/images/allBrokers/phpca.png",
      isShow: false,
      value: "phpca"
    },
    {
      name: "Central Valley PACE",
      imageURL: "assets/images/allBrokers/cvpace.png",
      isShow: false,
      value: "cvpace"
    },
    {
      name: "PACE Transportation",
      imageURL: "assets/images/allBrokers/pacetrans.png",
      isShow: false,
      value: "pacetrans"
    },
    {
      name: "Trans Dev",
      imageURL: "assets/images/allBrokers/transdev.png",
      isShow: false,
      value: "transdev"
    },
    {
      name: "Pacific Source",
      imageURL: "assets/images/allBrokers/pacificsource.png",
      isShow: false,
      value: "pacificsource"
    },
    {
      name: "Mōvi",
      imageURL: "assets/images/allBrokers/movi.png",
      isShow: false,
      value: "movi"
    },
    {
      name: "SoCal",
      imageURL: "assets/images/allBrokers/socal.png",
      isShow: false,
      value: "solcal"
    },
    {
      name: "Community Health Group",
      imageURL: "assets/images/allBrokers/community-health-group.png",
      isShow: false,
      value: "chgsd"
    }
  ]
  constructor() { }
  selectedCompanyName = null;
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (!this.selectedCompanyName && changes.preSelected && changes.preSelected.currentValue) {
      this.selectedCompanyName = changes.preSelected.currentValue
    }

  }
  selectedCompany(companyName) {
    this.submitted = true;
    this.selectedCompanyName = companyName;
    this.showList = !this.showList;
    this.selectedBroker.emit(companyName);
  }
  getSelectedBroker() {
    return this.brokers.find(data => data.value === this.selectedCompanyName)
  }

  closeDropdown() {
    this.showList = false;
  }
}
